import { useQuery } from '@apollo/react-hooks'

import type { IProduct } from '~/types/products'

import { suggestedProductsQuery } from '../gql/queries'

export const useSuggestedProducts = () => {
  return useQuery<{ suggestedProducts: IProduct[] }>(suggestedProductsQuery)
}
